import { ref, onBeforeMount } from 'vue'
import { useBackend } from '@/composables/Backend';
import { useTracking } from '@/composables/Tracking';

export function useCurrentUser(onLoggedIn, onNotLoggedIn) {
  const backend = useBackend();
  const track = useTracking();

  // properties
  const id = ref('');
  const isLoggedIn = ref(false);
  const firstName = ref('');
  const lastName = ref('');
  const email = ref('');
  const isTradeProfessional = ref(false);
  const since = ref(null);
  const isOptedOutOfTracking = ref(true);
  
  // functions
  function doLogin(username, password, onSuccess, onError) {
    backend.login(username, password)
      .then(result => {
        if (result.error) {
          if (onError) {
            onError(result.error)
          }
        }
        else {
          isLoggedIn.value = true;
          firstName.value = result.firstName;
          lastName.value = result.lastName;
          email.value = result.email;

          if (onSuccess) {
            onSuccess({ firstName, lastName, email, isTradeProfessional, since })
          }
        }
      });
  }

  // function doLogout(onSuccess, onError) {
  //   backend.logout()
  //     .then(result => {
  //       if (result && result.status && result.status == "success") {
  //         if (onSuccess) {
  //           onSuccess();
  //         }          
  //       }
  //       else {
  //         if (onError) {
  //           onError();
  //         }
  //       }
  //     });
  function doLogout(onSuccess, onError) {
    backend.logout()
      .then(result => {
        if (result && result.redirectUrl) {
          if (onSuccess) {
            onSuccess(result.redirectUrl); // Pass redirectUrl
          }
        } else {
          if (onError) {
            onError('No redirect URL returned');
          }
        }
      })
      .catch(err => {
        console.error('Logout error:', err);
        if (onError) {
          onError(err.message || 'Logout failed');
        }
      });
  }

  function doUpdate(newFirstName, newLastName, newEmail, onSuccess, onError) {
    backend.updateAccountInfo(newFirstName, newLastName, newEmail)
        .then(result => {
          if (result) {
            console.log('result: ', result)
            // request was successfully submitted, so check for returned error
            if (result.error) {
              if (onError) {
                onError(result.message);
              }
            }
            else {
              const firstName = result.firstName;
              const lastName = result.lastName;
              const email = result.email;

              console.debug('firstName: ', firstName);

              if (onSuccess) {
                onSuccess({ firstName, lastName, email, isTradeProfessional, since });
              }
            }
          }
          else {
            // something went wrong with the request
            if (onError) {
              onError("An unexpected error occurred.");
            }
          }
        });
  }

  // hooks
  onBeforeMount(() => {
    // see if user is logged in
    backend.getAccountInfo()
      .then(result => {
        if (result.error || result === false) {
          if (onNotLoggedIn) {
            onNotLoggedIn(result.error);
          }
        }
        else {
          // user is logged in    
          id.value = result.id;      
          isLoggedIn.value = true;
          firstName.value = result.firstName;
          lastName.value = result.lastName;
          email.value = result.email;
          isTradeProfessional.value = result.isTradeProfessional;
          since.value = result.since;
          isOptedOutOfTracking.value = result.isOptedOutOfTracking;

          // track user if not opted out
          if (!isOptedOutOfTracking.value) {
            track.currentUser(id.value, email.value, firstName.value, lastName.value);
          }

          if (onLoggedIn) {
            onLoggedIn({ firstName, lastName, email, isTradeProfessional, since });
          }
        }
      });
  });

  return {
    isLoggedIn,
    firstName,
    lastName,
    email,
    isTradeProfessional,
    since,
    doLogin,
    doLogout,
    doUpdate
  };
}